import React from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useAtom } from "jotai";
//form
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// mui
import { Card, Typography, CardContent, Stack, Button } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
// state
import { vesselAtom } from "../../../shared/state/atoms";
// hooks
import useSavingsForm from "../hooks/useSavingsForm";
import useIsMountedRef from "../../../shared/hooks/useIsMountedRef";
// components
import { FormProvider, RHFSelect } from "../../../shared/components/hook-forms";
// constants
import { VESSEL_OPTIONS } from "../../../shared/utils/constants";
// routes
import { ROOTS_SAVINGS } from "../../../shared/routes/paths";

export default function SavingsForm() {
  const navigate = useNavigate();
  const isMountedRef = useIsMountedRef();
  const [, setVessel] = useAtom(vesselAtom);
  const { handleCalculate } = useSavingsForm();

  const CalculatorSchema = Yup.object().shape({
    vesselType: Yup.string().required("Vessel type is required"),
    vesselSpeed: Yup.string().required("Vessel speed is required"),
  });

  const defaultValues = {
    vesselType: "",
    vesselSpeed: "",
  };

  const methods = useForm({
    resolver: yupResolver(CalculatorSchema),
    defaultValues,
  });

  const { reset, setError, watch, handleSubmit } = methods;

  const selectedVessel = watch("vesselType");

  const onSubmit = async (formData) => {
    try {
      const percentSavings = handleCalculate(formData);
      const data = {
        ...formData,
        percentSavings,
      };

      setVessel(data);
      navigate(ROOTS_SAVINGS);
    } catch (error) {
      console.error(error);

      reset();

      if (isMountedRef.current) {
        setError("afterSubmit", { ...error, message: error.message });
      }
    }
  };

  return (
    <Card sx={{ my: 2, border: 1, borderColor: "#858585", borderRadius: 5 }}>
      <CardContent sx={{ backgroundColor: "white" }}>
        <Typography
          sx={{ fontSize: 16, mb: 2, fontWeight: "600", fontFamily: "Rubik" }}
          color="inherit"
        >
          Fuel & Emission Savings
        </Typography>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={3}>
            <RHFSelect name="vesselType" label="Vessel Type">
              <option />
              {VESSEL_OPTIONS.map((option) => (
                <option key={option.name} value={option.name}>
                  {option.name}
                </option>
              ))}
            </RHFSelect>
            <RHFSelect name="vesselSpeed" label="Vessel Speed">
              <option disabled={!selectedVessel} />
              {selectedVessel &&
                VESSEL_OPTIONS.find(
                  (vessel) => vessel.name === selectedVessel
                ).speedOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
            </RHFSelect>
            <Button
              sx={{
                width: 120,
                borderRadius: 30,
                backgroundColor: "#5ED5A2",
                "&:hover": { backgroundColor: "#5ED5A2" },
              }}
              size="large"
              type="submit"
              variant="contained"
            >
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: "500",
                  fontFamily: "Rubik",
                  color: "white",
                  textTransform: "none",
                }}
                color="inherit"
              >
                Calculate
              </Typography>
              <KeyboardArrowRightIcon />
            </Button>
          </Stack>
        </FormProvider>
      </CardContent>
    </Card>
  );
}
